const CLIENT_CONFIGS = {
  // ── Alterna Sleep ─────────────────────────────────────────────────────────
  "journeys-sandbox.alternasleep.com": {
    clientId: "alterna",
    pageTitle: "Alterna Patient Communication",
    shortName: "Alterna",
    description: "Alterna patient communication forms.",
    favicon96: "https://alternasleep.com/wp-content/uploads/2024/05/cropped-favicon-32x32.png",
    favicon192: "https://alternasleep.com/wp-content/uploads/2024/05/cropped-favicon-192x192.png",
    logo: "https://alternasleep.com/wp-content/uploads/2024/05/logo.png",
    ogImage: "https://alternasleep.com/wp-content/uploads/2024/05/logo.png",
    ogUrl: "https://journeys-sandbox.alternasleep.com",
    themeColor: "#000000",
    backgroundColor: "#ffffff",
  },
  "journeys.alternasleep.com": {
    clientId: "alterna",
    pageTitle: "Alterna Patient Communication",
    shortName: "Alterna",
    description: "Alterna patient communication forms.",
    favicon96: "https://alternasleep.com/wp-content/uploads/2024/05/cropped-favicon-32x32.png",
    favicon192: "https://alternasleep.com/wp-content/uploads/2024/05/cropped-favicon-192x192.png",
    logo: "https://alternasleep.com/wp-content/uploads/2024/05/logo.png",
    ogImage: "https://alternasleep.com/wp-content/uploads/2024/05/logo.png",
    ogUrl: "https://journeys.alternasleep.com",
    themeColor: "#000000",
    backgroundColor: "#ffffff",
  },

  // ── Fallback (HealthBlox own domains) ────────────────────────────────────
  default: {
    clientId: "healthblox",
    pageTitle: "HealthBlox Care Flow",
    shortName: "HealthBlox",
    description:
      "HealthBlox is a healthcare Automation Platform that makes it easier for you to use your EHR.",
    favicon96: "/favicon-black-96.png",
    favicon192: "/favicon-black-192.png",
    favicon96Dark: "/favicon-white-96.png",
    favicon192Dark: "/favicon-white-192.png",
    ogImage: "/preview-image.png",
    ogUrl: "https://journey.healthblox.care",
    themeColor: "#000000",
    backgroundColor: "#ffffff",
  },
};

export const getClientConfig = () => {
  const hostname = window.location.hostname;
  return CLIENT_CONFIGS[hostname] ?? CLIENT_CONFIGS["default"];
};
